<template>
  <div>
    <van-overlay :show="dialogLoding" class="overlay_box" z-index="999" :lock-scroll="true">
      <van-loading />
    </van-overlay>
    <img v-if="hasExtend" class="extend_img" src="@/assets/img/mobile-img/detail-extend.png" alt="" @click="toExtend" />
    <van-dialog v-model="extendShow" :show-confirm-button="false" class="extend_dialog">
      <img class="dialog_img" src="@/assets/img/mobile-img/detail-extend-icon.png" />
      <img class="dialog_close" src="@/assets/img/mobile-img/dialog-close.png" @click="extendShow = false" />
      <h2 class="dialog_title">确认开通分享推广吗？</h2>
      <p class="dialog_text">将获得高额佣金返现</p>
      <van-button round type="info" class="dialog_btn" @click="$router.push('/extend/no-extend')">确认开通</van-button>
    </van-dialog>
    <van-popup :lock-scroll="true" v-model="sharePopup" class="tool-popup" round position="bottom"
      :close-on-click-overlay="false">
      <ul class="share-icon-box">
        <li class="share-item" v-for="item in shareList" :key="item.key" @click="toShare(item.key)">
          <img class="share-icon" :src="item.img" alt="" />
          <p>{{ item.name }}</p>
        </li>
      </ul>
      <div class="tool-popup-btn" @click="sharePopup = false">取消</div>
    </van-popup>
  </div>
</template>

<script>
import Mshare from "m-share";
import { Toast } from "vant";
export default {
  props: ["hasExtend", "shareInfo"],
  data() {
    return {
      extendShow: false,
      sharePopup: false,
      showPoster: false,
      dialogLoding: false,
      shareList: [
        {
          key: "img",
          name: "图片分享",
          img: require("@/assets/img/mobile-img/share-img.png"),
        },
        // {
        //   key: "wx",
        //   name: "微信",
        //   img: require("@/assets/img/mobile-img/wx.png"),
        // },
        // {
        //   key: "pyq",
        //   name: "朋友圈",
        //   img: require("@/assets/img/mobile-img/pxq.png"),
        // },
        // {
        //   key: "qq",
        //   name: "QQ",
        //   img: require("@/assets/img/mobile-img/qq.png"),
        // },
        // {
        //   key: "qqkj",
        //   name: "QQ空间",
        //   img: require("@/assets/img/mobile-img/qqkj.png"),
        // },
        // {
        //   key: "wb",
        //   name: "新浪微博",
        //   img: require("@/assets/img/mobile-img/wb.png"),
        // },
        {
          key: "link",
          name: "复制链接",
          img: require("@/assets/img/mobile-img/copy-link.png"),
        },
      ],
      MshareInfo: {
        title: "",
        desc: "",
        link: "",
        imgUrl: "",
      },
    };
  },
  watch: {
    shareInfo: {
      handler(newV) {
        let link = this.eliminate();
        if (sessionStorage.getItem("userInfo")) {
          const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
          link = link + "promoterId=" + userInfo.promoterId;
        }
        this.MshareInfo = {
          title: this.$global.matchReg(newV.title) + " - 中文知识网",
          desc: newV.artSummary ? this.$global.matchReg(newV.artSummary) : "",
          link,
          imgUrl: newV.cover ? `${this.$global.imgUrl}${newV.cover}` : "",
        };
        Mshare.init(this.MshareInfo);
      },
      deep: true,
    },
  },
  methods: {
    // 点击分享
    toShare(type) {
      switch (type) {
        case "wx":
          Mshare.to("wx", this.MshareInfo);
          break;
        case "pyq":
          Mshare.to("wxline", this.MshareInfo);
          break;
        case "qq":
          Mshare.to("qq", this.MshareInfo);
          break;
        case "qqkj":
          Mshare.to("qzone", this.MshareInfo);
          break;
        case "wb":
          Mshare.to("sina", this.MshareInfo);
          break;
        case "link":
          const input = document.createElement("input");
          input.setAttribute("readonly", "readonly");
          input.setAttribute("value", this.MshareInfo.link);
          document.body.appendChild(input);
          input.select();
          if (document.execCommand("copy")) {
            document.execCommand("copy");
            Toast({ message: '链接已复制',className:"myToast"  });
          }
          document.body.removeChild(input);
          break;
        case "img":
          this.sharePopup = false;
          this.showPoster = true;
          this.$bus.$emit("posterVisibleStatus", this.showPoster);
          this.$emit("sharePoster", this.showPoster);
          break;
      }
    },
    // 点击推广
    async toExtend() {
      const tokens = sessionStorage.getItem("token");
      if (tokens) {
        this.dialogLoding = true
        this.getAuthorityToExtend();
        // 获取用户信息
        // let data = await this.$apis.loginServe.getUserInfo();
        // sessionStorage.setItem("userInfo", JSON.stringify(data.content));
      } else {
        if (this.$route.query.out) {
          if (this.$global.isAndroid_ios()) {
            window.android.getToken();
          } else {
            window.webkit.messageHandlers.getToken.postMessage("null"); //ios
          }
        } else {
          this.$router.push("/logins");
        }
      }
    },

    // 获取用户信息(推广权限)调用推广功能
    async getAuthorityToExtend() {
      const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      if (userInfo.promoterId && userInfo.promoterId !== "") {
        // 判断该用户推广权限是否被关闭
        let res = await this.$apis.extendServe.hasExtendLimits();
        if (res.resultCode === "200") {
          // 推广功能被关闭
          if (res.data.fgDis === 1) {
            if (this.$route.query.out) {
              this.dialogLoding = false;
              if (this.$global.isAndroid_ios()) {
                // promotionStatusDialog 告诉APP端推广用户权限状态
                //  1 权限已关闭  2 没有推广权限
                window.android.promotionStatusDialog("1");
              } else {
                window.webkit.messageHandlers.promotionStatusDialog.postMessage(
                  "1"
                ); //ios
              }
            } else {
              this.$router.push("/extend/close-extend");
            }
          } else {
            let { resultCode } = await this.$apis.extendServe.setExtendInfo({
              goodsId: this.shareInfo.goodsId,
              goodsTypeId: this.shareInfo.goodsTypeId,
            });
            if (resultCode === "200") {
              this.dialogLoding = false;
              this.openShare(userInfo.promoterId);
            }
          }
        }
      } else {
        if (this.$route.query.out) {
          this.dialogLoding = false;
          if (this.$global.isAndroid_ios()) {
            // promotionStatusDialog 告诉APP端推广用户权限状态
            //  1 权限已关闭  2 没有推广权限
            window.android.promotionStatusDialog("2");
          } else {
            window.webkit.messageHandlers.promotionStatusDialog.postMessage(
              "2"
            ); //ios
          }
        } else {
          this.dialogLoding = false;
          this.extendShow = true;
        }
      }
    },
    // 打开分享弹窗
    openShare(promoterId) {
      if (this.$route.query.out) {
        let Url = this.eliminate();
        let appShareInfo = {
          ...this.shareInfo,
          isCollect: sessionStorage.getItem("isCollect"),
          pageUrl: Url + "share=false&promoterId=" + promoterId,
          shareBox: "bottom",
          isExtend: true,
        };
        console.log(appShareInfo, "appShareInfo");
        const shareJson = JSON.stringify(appShareInfo);
        if (this.$global.isAndroid_ios()) {
          window.android.sharing(shareJson);
        } else {
          window.webkit.messageHandlers.sharing.postMessage(shareJson); //ios
        }
      } else {
        this.sharePopup = true;
      }
    },

    // 分享 复制链接剔除特殊字段
    eliminate() {
      let url = document.location.toString();
      let urlArr = url.split("?");
      let baseUrl = urlArr[0] + "?";
      let params = Object.create(null);
      if (urlArr.length > 1) {
        urlArr = urlArr[1].split("&");
        urlArr.forEach((item) => {
          item = item.split("=");
          if (
            item[0] === "out" ||
            item[0] === "app" ||
            item[0] === "share" ||
            item[0] === "token" ||
            item[0] === "promoterId"
          ) {
            return;
          }
          {
            params[item[0]] = item[1];
          }
        });
      }
      for (const key in params) {
        baseUrl = baseUrl + [key] + "=" + params[key] + "&";
      }
      return baseUrl;
    },
  },
};
</script>

<style lang="scss" scoped>
.extend_img {
  position: fixed;
  right: 0;
  bottom: 150px;
  width: 91px;
  height: 35px;
}

.extend_dialog {
  // position: relative;
  padding: 20px 20px 50px;
  text-align: center;

  .dialog_img {
    width: 75px;
    height: 75px;
  }

  .dialog_close {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 13px;
    height: 13px;
  }

  .dialog_title {
    margin: 13px 0;
    font-size: 18px;
    color: #000000;
    line-height: 25px;
  }

  .dialog_text {
    font-size: 14px;
    color: #333333;
    line-height: 20px;
  }

  .dialog_btn {
    margin-top: 24px;
    width: 150px;
    height: 40px;
    border-radius: 22px;
    background: #4a79f1;
  }
}

// 分享面板
.tool-popup {
  background-color: #f5f5f5;

  .share-icon-box {
    padding: 20px 12px 70px;
    white-space: nowrap;
    overflow-x: auto;

    .share-item {
      display: inline-block;
      margin: 0 12px;
      // width: 44px;
      text-align: center;

      .share-icon {
        width: 44px;
        height: 44px;
      }
    }
  }

  // 分享面板中分享按钮
  .tool-popup-btn {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 15px 0;
    width: 100%;
    background-color: #fff;
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    color: #333333;
    line-height: 21px;
  }
}

.overlay_box {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>